<div class="auth-container">
  <mat-card class="rp-card">
    <mat-card-header class="card-header">
      <mat-card-title>Authentication Required</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form (keydown.enter)="submit()" class="form">
        <mat-form-field appearance="fill">
          <mat-label>Authentication Code</mat-label>
          <input matInput type="text" placeholder="Enter code" [formControl]="authenticationCodeFormControl">
        </mat-form-field>
      </form>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="primary" (click)="submit()">Submit</button>
    </mat-card-actions>
  </mat-card>
</div>

